import styled from 'styled-components'
import theme from '../../../styles/theme'

const StContent = styled.div`
  padding-top: 4rem;
  h2{
    padding: 2rem 1rem;
  }
`

export { StContent }